import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {Button} from 'reactstrap';

export class FormAsyncButton extends Component {
    render() {
        const {acting, disabled, children, ...props} = this.props;

        return (
            <Button disabled={acting || disabled} {...props}>
                <div style={{position: "relative"}}>
                                            <span style={{visibility: acting ? 'hidden' : 'visible'}}>
                                                {children}
                                            </span>
                    <div className="animated fadeIn"
                         style={{position: 'absolute', left: 0, right: 0, top: 'calc(50% - 10px)', display: acting ? 'inherit' : 'none'}}>
                        <i className="fa fa-spinner fa-pulse"/>
                    </div>
                </div>
            </Button>
        );
    }
}

FormAsyncButton.propTypes = {
    acting: PropTypes.any.isRequired
};

export class AsyncButton extends Component {
    constructor(props) {
        super(props);
        this.onComplete = this.onComplete.bind(this);
    }

    state = {
        acting: false
    };

    onComplete() {
        this.setState({acting: false});
        this.props.onComplete && this.props.onComplete();
    }

    render() {
        const {disabled, children, task, noComplete, ...props} = this.props;
        const {acting} = this.state;

        return (
            <Button disabled={acting || disabled} {...props} onClick={() => {
                this.setState({acting: true});
                if (noComplete) {
                    task().then(() => this.onComplete());
                } else {
                    task();
                }

            }}>
                <div style={{position: "relative"}}>
                                            <span style={{visibility: acting ? 'hidden' : 'visible'}}>
                                                {children}
                                            </span>
                    <div className="animated fadeIn"
                         style={{position: 'absolute', left: 0, right: 0, top: 'calc(50% - 10px)', display: acting ? 'inherit' : 'none'}}>
                        <i className="fa fa-spinner fa-pulse"></i>
                    </div>
                </div>
            </Button>
        );
    }
}

AsyncButton.propTypes = {
    task: PropTypes.func.isRequired,
    onComplete: PropTypes.func,
    noComplete: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/controls/buttons/AsyncButton.js